import { useEffect, useState } from 'react';

export const THIRD_PARTY_SCRIPT_LOADED_EVENT = 'third-party-script-loaded';

const isGlobalDefined = (globalName: string) => globalName in window;

export const useThirdPartyGlobalReady = (globalName: string) => {
  const [isReady, setIsReady] = useState(() => isGlobalDefined(globalName));

  useEffect(() => {
    if (isReady) return undefined;

    const markReadyWhenDefined = () => {
      if (isGlobalDefined(globalName)) setIsReady(true);
    };
    markReadyWhenDefined();
    window.addEventListener(THIRD_PARTY_SCRIPT_LOADED_EVENT, markReadyWhenDefined);
    return () => window.removeEventListener(THIRD_PARTY_SCRIPT_LOADED_EVENT, markReadyWhenDefined);
  }, [globalName, isReady]);

  return isReady;
};
